import type { Header } from "@tanstack/react-table";

export function ColumnResizer<TData, TValue>({
	header,
}: {
	header: Header<TData, TValue>;
}) {
	if (header.column.getCanResize() === false) return <></>;

	return (
		<div
			{...{
				onMouseDown: header.getResizeHandler(),
				onTouchStart: header.getResizeHandler(),
				className:
					"absolute top-0 right-0 cursor-col-resize w-px h-full bg-[#e0e0e0] hover:bg-[#e5e5e5] hover:w-2 transition",
				style: {
					userSelect: "none",
					touchAction: "none",
				},
			}}
		/>
	);
}
